import { DateInfo } from './types';

/**
 * Generates an array of dates for the date picker in UTC
 * @param days Number of days to generate (default: 7)
 * @returns Array of DateInfo objects
 */
export const generateDates = (days: number = 7, demo: boolean = false): DateInfo[] => {
  let base = new Date();
  if (demo) {
    base = new Date('2025-08-16T00:00:00Z');
  }

  const dates = Array.from({ length: days }, (_, i) => {
    const date = new Date(base);
    date.setUTCDate(base.getUTCDate() - (days - 1 - i));
    return {
      day: date.getUTCDate().toString(),
      month: (date.getUTCMonth() + 1).toString(),
      year: date.getUTCFullYear().toString(),
    };
  });
  return dates;
};

/**
 * Checks if we're at the first date position
 * @param currentIndex Current date index
 * @returns boolean
 */
export const isAtFirstDate = (currentIndex: number): boolean => currentIndex === 0;

/**
 * Checks if we're at the last date position
 * @param currentIndex Current date index
 * @param maxIndex Maximum possible index
 * @returns boolean
 */
export const isAtLastDate = (currentIndex: number, maxIndex: number): boolean =>
  currentIndex >= maxIndex;

/**
 * Gets the visible dates for the current view
 * @param dates All available dates
 * @param currentIndex Current starting index
 * @param visibleCount Number of dates to show (default: 2)
 * @returns Array of visible dates
 */
export const getVisibleDates = (
  dates: DateInfo[],
  currentIndex: number,
  visibleCount: number = 2,
): DateInfo[] => {
  return dates.slice(currentIndex, currentIndex + visibleCount);
};

/**
 * Calculates the maximum index for date navigation
 * @param totalDates Total number of dates
 * @param visibleCount Number of visible dates at once
 * @returns Maximum index
 */
export const getMaxDateIndex = (totalDates: number, visibleCount: number = 2): number => {
  return totalDates - visibleCount;
};
